import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { UIComponentViewImpl } from "../../../../toolkit/uicomponentview";
import { LoaderWrapperComponent } from "../../loaderwrappercomponent";
import { CreateFlashMessageComponentHandler, CreateFlashMessageComponentProps, CreateFlashMessageComponentState } from "./createflashmessagecomponent";
import * as React from "react";
import { ButtonComponent } from "../../../../toolkit/button/buttoncomponent";
import { ConfirmRequestConfirmButtonCSSStyleImpl } from "../../confirmrequest/confirmrequestconfirmbuttoncss";
import { SubscriptionPlanCancelButtonCSSStyleImpl } from "../../subscription_plan/subscriptionplancancelbuttoncss";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { CreateFlashMessageCSSStyle } from "./createflashmessagecss";
import { LoaderComponent } from "../../../../toolkit/loader/loadercomponent";
import './createflashmessage-style.css';
import { ConfirmFlashMessageComponent } from "../confirmflashmessage/confirmflashmessagecomponent";

export class CreateFlashMessageViewImpl extends UIComponentViewImpl<FlashMessageDto>
{

    private loaderWrapperComponent:LoaderWrapperComponent;
    private textAreaRef:any;
    bindHandlers()
    {   
        this.onClosePopup = this.onClosePopup.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.onYesClick = this.onYesClick.bind(this);
        this.onNoClick = this.onNoClick.bind(this);
    }

    draw(props: CreateFlashMessageComponentProps, state: CreateFlashMessageComponentState, cssStyle: CreateFlashMessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                {
                    this.getWebView(props, state, cssStyle)
                }

                  <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>

            </div>
        );
    }


    getWebView(props: CreateFlashMessageComponentProps, state: CreateFlashMessageComponentState, cssStyle: CreateFlashMessageCSSStyle):JSX.Element
    { 
        return(
            <>
             {!state.showConfirmation && <>
                    <div style={cssStyle.getHeaderDivCSSStyle()}>
                        <label id="create-flash-msg-header-title" style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                        <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onClosePopup}>
                            <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                        </div>
                    </div>
                    <div id="create-flash-msg-main">
                            <div id="create-flash-msg-header-main">
                                    <div id="create-flash-msg-content-div" style={{}}>
                                       <label id="create-flash-msg-edit-label" style={{fontFamily:this.getContext().getResources().getFontFamily(),fontWeight:500}}>
                                            {state.isMessageEditable ? this.getContext().getResources().getString(Strings.edit_your_flash): this.getContext().getResources().getString(Strings.create_your_flash)}
                                       </label>
                                       <textarea id="create-flash-msg-area" ref={(item:any)=>this.textAreaRef = item} rows={4} cols={50} maxLength={160} autoFocus={true}>
                                        {!state.isMessageEditable ? props.flashMessageDto.getStatusMessage(): this.getContext().getResources().getString(Strings.enter_your_message)}
                                        </textarea>
                                         <div id="create-flash-msg-limit" style={{ }}>
                                                {this.getContext().getResources().getString(Strings.flash_message_limit)}
                                         </div>
                                    </div>
                             </div> 
                    </div>         
                    <div id="create-confirm-flash-msg-button-div" style={{}}>
                            <div id="create-flash-msg-button1-div" style={{}}>
                                <ButtonComponent onClick={this.onCancelClick} style={new SubscriptionPlanCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                            </div>
                            <div id="create-flash-msg-button2-div" style={{}}>
                                <ButtonComponent onClick={this.onNextClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.next)}/>
                            </div>
                    </div>         
                    </>
            }

            {state.showConfirmation &&
            <ConfirmFlashMessageComponent context={props.context} headerTitle={props.context.getResources().getString(Strings.confirmation)} confirmMessage={state.isMessageEditable ? props.context.getResources().getString(Strings.edit_flash_confirmation) : props.context.getResources().getString(Strings.create_flash_confirmation)} closePopup={this.onCancelClick} onNoClick={this.onNoClick} onYesClick={this.onYesClick}/>
            }
            </>
        );
    }

    onNoClick()
    {
        (this.getUIComponentHandler() as CreateFlashMessageComponentHandler).toggleConfirmPopup(false);
    }

    onYesClick()
    {
        (this.getUIComponentHandler() as CreateFlashMessageComponentHandler).toggleConfirmPopup(true);
    }

    showLoader()
    {       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    onNextClick()
    {  
        (this.getUIComponentHandler() as CreateFlashMessageComponentHandler).onNextClick(this.textAreaRef.value);
    }
    onCancelClick()
    {
        (this.getUIProps() as CreateFlashMessageComponentProps).closePopup();
    }
    onClosePopup():void
    {
        (this.getUIProps() as CreateFlashMessageComponentProps).closePopup();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/createflashmessage/createflashmessageview.tsx